// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
import fbCon from "../json/firebase.json";

const firebaseConfig = {
  apiKey: fbCon.apiKey,
  authDomain: fbCon.authDomain,
  projectId: fbCon.projectId,
  storageBucket: fbCon.storageBucket,
  messagingSenderId: fbCon.messagingSenderId,
  appId: fbCon.appId,
  measurementId: fbCon.measurementId,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();

// HELPER
export const provider = new firebase.auth.GoogleAuthProvider();
export const serverTime = firebase.firestore.FieldValue.serverTimestamp();
export const tsToMillis = firebase.firestore.Timestamp.now().toMillis();

export const validDays = 90 * 24 * 60 * 60 * 1000;

export const eventChanged = firebase.storage.TaskEvent.STATE_CHANGED;
export const eventPaused = firebase.storage.TaskState.PAUSED;
export const eventRunning = firebase.storage.TaskState.RUNNING;
